import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { Natura } from "../../../../common/models/tipologiche/natura";
import { SoggettoPratica } from '../../../../common/models/tipologiche/soggetto-pratica';
import { TipoTipologica } from "../../../../common/models/tipologiche/tipo-tipologica";

export class FascicoloAmianto extends FascicoloFull {
  societa: SoggettoPratica;
  natura: Natura = {
    id: '2',
    descrizione: 'Passivo',
    label: 'PASSIVO',
    rimosso: false
  };
  foro: TipoTipologica;
  conciliazione: boolean;
  lavoratore: string;
  profiloProfessionale: TipoTipologica;
  impianto: TipoTipologica;
  esposizione: boolean;
  dataConciliazione: number;
  importoConciliazione: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
